import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './ReviewReel.css';

function ReviewReel({reviewImages}) {
    return (
      <div>
        <h2 className="reviewHeader">Reviews</h2>
        <Carousel className='reviewReel'preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}  showIndicators={false} dynamicHeight={true} emulateTouch={true} infiniteLoop={true} selectedItem={0} showStatus={false} showThumbs={false}>
          {reviewImages.map((image, index) => <div key={index} className="reviewImgContainer"><img src={image} alt="" className='reviewImg'/></div>)}
        </Carousel>

      </div>
    )
  }

  export default ReviewReel;